export default "__VITE_ASSET__BQRSc5dF__"